
import { defineComponent, onMounted, reactive, ref  } from "vue";
import axios from "@/utils/axios";

import Swiper from "./modules/swiper.vue";
import SubNav from "./modules/subNav.vue";
import LongBox from "./modules/longBoxa.vue";
import MiddleBox from "./modules/middleBox.vue";
import Message from "@/components/message/Message.vue";
import { onBeforeRouteUpdate } from "vue-router";
import { useRoute } from 'vue-router'
export default defineComponent({
  name: "home",
  components: {
    Swiper,
    SubNav,
    LongBox,
    MiddleBox,
    Message,
  },
  data() {
    return {
      tabPosition: "left",
      glassImg: require("@/assets/1new/赋能工程/2.jpg"),
      currentPage1: 1,
      currentPage2: 1,
      currentPage3: 1,
      activeTab: '3',
      messList: [
        {
          id: 1,
          mess: "高考新政自2014年实施以来，截至目前北京、天津、山东、海南、河北、湖南、",
        },
        {
          id: 2,
          mess: "2高考新政自2014年实施以来，截至目前北京、天津、山东、海南、河北、湖南、",
        },
        {
          id: 3,
          mess: "3高考新政自2014年实施以来，截至目前北京、天津、山东、海南、河北、湖南、",
        },
        {
          id: 3,
          mess: "3高考新政自2014年实施以来，截至目前北京、天津、山东、海南、河北、湖南、",
        },
      ],
    };
  },
  methods: {
    goDetail(id: any) {
      // console.log(id);
      this.$router.push({ name: "newsDetail", params: { id: id } });
      // window.open(href, "_blank");
    },
    // handleSizeChange(val: any) {
    //   console.log(`每页 ${val} 条`);
    // },

    // handleSizeChange2(val: any) {
    //   console.log(`每页 ${val} 条`);
    // },
    // handleCurrentChange2(val: any) {
    //   console.log(`当前页: ${val}`);
    // },
  },
  setup() {
    var count = reactive({ data: "" });
    var count2 = reactive({ data: "" });
    var count3 = reactive({ data: "" });
    var activeCount = reactive({ data: "3" });
    var searchMess = ref();
    var mess = reactive({ data: "" });
    var active = reactive({ data: "" });
    var school = reactive({ data: "" });
    const route = useRoute()
    onMounted(() => {
      var id:any = route.params
      console.log('路由导航守卫',id)
      switch( id ){
        case 1:
       activeCount.data = '1'
        break;
           case 2:
       activeCount.data = '2'
        break;
           case 3:
       activeCount.data = '3'
        break;
      }
    })
    // 小新快讯 1 行业动态2  实践校3
    axios
      .get(
        "https://www.xsy985.com/api/news/news?page=1&page_size=5&news_type=1"
      )
      .then(function (response) {
        // console.log(response.data, "资讯");
        mess.data = response.data.results;
        count.data = response.data.count;
      })
      .catch(function (error) {
        console.log(error);
      });
    axios
      .get(
        "https://www.xsy985.com/api/news/news/?page=1&page_size=5&news_type=2"
      )
      .then(function (response) {
        // console.log(response.data,"动态");
        count2.data = response.data.count;
        active.data = response.data.results;
      })
      .catch(function (error) {
        console.log(error);
      });
       axios
      .get(
        "https://www.xsy985.com/api/news/news/?page=1&page_size=5&news_type=3"
      )
      .then(function (response) {
        // console.log(response.data,"动态");
        count3.data = response.data.count;
        school.data = response.data.results;
      })
      .catch(function (error) {
        console.log(error);
      });
    //  新闻资讯翻页
    const handleCurrentChange = (val: any) => {
      console.log(` ${val} ye`);
      axios
        .get(
          `https://www.xsy985.com/api/news/news?page=${val}&page_size=5&news_type=1`
        )
        .then(function (response) {
          // console.log(response.data);
          mess.data = response.data.results;
          window.scrollTo(0, 300);
        })
        .catch(function (error) {
          console.log(error);
        });
    };
    //  动态翻页
    const handleCurrentChange2 = (val: any) => {
      console.log(` ${val} ye`);
      axios
        .get(
          `https://www.xsy985.com/api/news/news?page=${val}&page_size=5&news_type=2`
        )
        .then(function (response) {
          // console.log(response.data);
          active.data = response.data.results;
          window.scrollTo(0, 300);
        })
        .catch(function (error) {
          console.log(error);
        });
    };
       const handleCurrentChange3 = (val: any) => {
      console.log(` ${val} ye`);
      axios
        .get(
          `https://www.xsy985.com/api/news/news?page=${val}&page_size=5&news_type=3`
        )
        .then(function (response) {
          // console.log(response.data);
          school.data = response.data.results;
          window.scrollTo(0, 300);
        })
        .catch(function (error) {
          console.log(error);
        });
    };
    // 搜索
    const searchNews = (val: any) => {
      console.log(val, "搜索内容");
      axios
        .get(
          `https://www.xsy985.com/api/news/searchnews/?page=1&title=${val}`
        )
        .then(function (response) {
          console.log(response.data, "搜索结果");
          mess.data = response.data.results;
          active.data = response.data.results;
          if (response.data.count == 0) {
            mess.data = "暂无";
            active.data = "暂无";
          }
          window.scrollTo(0, 0);
        })
        .catch(function (error) {
          console.log(error);
        });
      // 搜索

    };

    return {
      mess,
      active,
      school,
      count,
      count2,
      count3,
      handleCurrentChange,
      handleCurrentChange2,
      handleCurrentChange3,
      searchNews,
      searchMess,
      activeCount,
    };
  },
});
